"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WholesaleShippingMethod = void 0;
exports.WholesaleShippingMethod = {
    Seller: "SELLER",
    Deliverr: "DELIVERR",
    Collect: "COLLECT",
};
//# sourceMappingURL=wholesale-shipping-method.js.map